const StarSticker = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
    >
      <path
        d="M45.6 18.9882L51.2569 13.3314"
        stroke="#EBB268"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M19.5882 18.9882L13.9314 13.3314"
        stroke="#EBB268"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M9.60001 45.3882L15.2569 39.7314"
        stroke="#EBB268"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M55.2 45.4L49.5432 39.7431"
        stroke="#EBB268"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M32 58.6V50.6"
        stroke="#EBB268"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M30.5734 15.3906C31.0224 14.0086 32.9776 14.0086 33.4266 15.3906L36.6923 25.4415C36.8932 26.0596 37.4691 26.478 38.1189 26.478L48.6871 26.478C50.1402 26.478 50.7444 28.3374 49.5688 29.1915L41.019 35.4034C40.4932 35.7854 40.2732 36.4624 40.4741 37.0804L43.7398 47.1314C44.1888 48.5134 42.6071 49.6626 41.4315 48.8085L32.8817 42.5966C32.356 42.2146 31.6441 42.2146 31.1183 42.5966L22.5685 48.8085C21.3929 49.6626 19.8112 48.5134 20.2602 47.1314L23.526 37.0804C23.7268 36.4624 23.5068 35.7854 22.9811 35.4034L14.4312 29.1915C13.2556 28.3374 13.8598 26.478 15.3129 26.478L25.8811 26.478C26.5309 26.478 27.1069 26.0596 27.3077 25.4415L30.5734 15.3906Z"
        fill="#2D061B"
      />
      <path
        d="M4 27.4H8.8"
        stroke="#EBB268"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M32 9.79999V4.99999"
        stroke="#EBB268"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M55.2 27.4H60"
        stroke="#EBB268"
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default StarSticker;
